import { forwardRef } from 'react';

export const THEMES: Record<string, string> = {
  CREATED: 'primary',
  ONGOING: 'primary',
  ALERT: 'primary',
  FUNDED: 'primary',
  IN_DELIVERY: 'primary',
  COLLECTED: 'warning',
  PENDING: 'warning',
  PENDING_PAYMENT: 'warning',
  AWAITING_RELEASE: 'warning',
  SUSPENDED: 'warning',
  WARNING: 'warning',
  ARCHIVED: 'warning',
  CANCELED: 'warning',
  CLOSED: 'warning',
  PARTIALLY_COMPLETED: 'warning',
  VALIDATING: 'warning',
  REJECTED: 'danger',
  STARTED: 'danger',
  FAILED: 'danger',
  ERRORED: 'danger',
  INACTIVE: 'danger',
  FAILURE: 'danger',
  CRITICAL: 'danger',
  DISPUTED: 'danger',
  DEACTIVATED: 'danger',
  ERROR: 'danger',
  SUCCESS: 'success',
  VERIFIED: 'success',
  SUCCESSFUL: 'success',
  SUCCESSFULL: 'success',
  REFUNDED: 'success',
  DELIVERED: 'success',
  PAID: 'success',
  COMPLETED: 'success',
  ACTIVE: 'success',
  ACTIVATED: 'success',
  INFO: 'success',
  OPEN: 'success',
  RELEASED: 'success',
  LIVE: 'success',
  SETUP: 'info',
  LIMITED: 'warning',
  REVIEW: 'warning',
  EXPIRED: 'info',
  PAYMENT_FAILED: 'danger',
  CANCELLED: 'dark',
  NOTICE: 'dark',
  NOT_STARTED: 'dark',
  DEBUG: 'info',
  PARTIALLY_RELEASED: 'info',
  PREPARING: 'info',
  READY_FOR_DELIVERY: 'info',
};

const HStatus = forwardRef<
  HTMLSpanElement,
  { label: string; status: string; 'data-cy'?: string }
>(({ label, status, 'data-cy': dataCy }, ref) => {
  const statusKey = status?.trim()?.toUpperCase();
  const theme = THEMES[statusKey] ?? 'secondary';

  return (
    <span
      ref={ref}
      className={`badge badge-${theme} fs-7 fw-semibold`}
      data-cy={dataCy}
    >
      {label}
    </span>
  );
});

HStatus.displayName = 'HStatus';

export default HStatus;
